<template lang="pug">
div
    modal(v-show="isShowModal_",:titulo="'ACTUALIZACION ' + nameModulo.toUpperCase()" bindClass="col-md-4 col-sm-12" , @close="isShowModal_=false")
        div(slot='body')  
            .form-group
                .form-row
                    .col-md-12.col-sm-12
                        label Nombre Tipo Lista
                        input.form-control.form-control-sm(v-model="parameter.Name", @keypress.enter="sendInfo()") 
                .form-row
                    .col-md-12.col-sm-12
                        label Envio de Email
                        div
                            i.fa.fa-toggle-off.fa-2x(v-if="parameter.IsActiveEmail==2", @click="parameter.IsActiveEmail=1")  OFF                                                    
                            i.fa.fa-toggle-on.fa-2x(v-if="parameter.IsActiveEmail==1" ,@click="parameter.IsActiveEmail=2" )   ON                  
                .form-row
                    .col-md-12.col-sm-12
                        label Estado
                        div
                            i.fa.fa-toggle-off.fa-2x(v-if="parameter.Active==2", @click="parameter.Active=1")  OFF                                                    
                            i.fa.fa-toggle-on.fa-2x(v-if="parameter.Active==1" ,@click="parameter.Active=2")   ON
        div(slot='footer')                      
            button.btn.btn-primary(@click="sendInfo()") Guardar
                       
</template>
<script>
import modal from "../../../complementos/modal.vue"
export default {
    props:{ 
        nameModulo:String,
        IsShowModal:Boolean,
        parameter:Object
    },
    data(){
        return{ 
            }
    },
    components:{
        modal
    },
    computed:{
        isShowModal_ :{
                        get(){return this.IsShowModal },
                        set(val){this.$emit("update:IsShowModal",val)}
        } 
    },
    methods:{ 
            sendInfo(){
                if(this.validate()){
                    this.$emit("update:parameter",this.parameter)            
                    this.$emit("sendInfo",this.parameter)
                }         
            },
            validate(){ 
                if(this.parameter.Name=='' || this.parameter.Name==null ){
                    this.$msgbox.show("Ingrese Nombre","Alerta")
                    return false
                }  
                else{
                    return true
                }
            }
    }

    
}
</script>